import React, { useState } from 'react'
import FormLayout from '../layout/FormLayout';
import { useTranslation } from 'react-i18next';
import downloadExcel from '../../../http/ExcelRequest';
import { DOWNLOAD_PRODUCT_REPORT } from '../../../data/url';

export default function Product() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    formTitle: 'Export GSTR1',
    formFields: [
      { label: 'from_date', id: 'from_date', type: 'date', name: 'from_date', value: '', className: "col-md-6" },
      { label: 'to_date', id: 'to_date', type: 'date', name: 'to_date', value: '', className: "col-md-6" },
    ],
    formErrors: { from_date: '', to_date: '' },
  });

  const handleFieldChange = (fieldName, value) => {
    setFormData((prevFormData) => {
      const updatedFormFields = prevFormData.formFields.map((field) =>
        field.name === fieldName ? { ...field, value: value } : field
      );
      return {
        ...prevFormData,
        formFields: updatedFormFields,
      };
    });
  }

  const handleFieldBlur = () => { }

  const handleSubmit = (e) => {
    e.preventDefault();
    let post = {};
    const updatedFormFields = formData.formFields.map((field) => {
      post[field.name] = field.value;
      return field;
    });
    setFormData((prevFormData) => ({
      ...prevFormData,
      formFields: updatedFormFields,
    }));
    let filename = 'PRODUCT-REPORT';
    downloadExcel(filename, DOWNLOAD_PRODUCT_REPORT, post);
  }
  return (
    <div className='col-md-8 m-auto '>
      <div className='card' style={{ borderRadius: "0px" }}>
        <div className='card-header'>
          <h5 className='card-title m-auto'>{t('product_inventory')}</h5>
        </div>
        <div className='card-body'>
          <FormLayout
            formTitle={formData.formTitle}
            formFields={formData.formFields}
            formErrors={formData.formErrors}
            onFieldChange={handleFieldChange}
            onFieldBlur={handleFieldBlur}
            onSubmit={handleSubmit}
            isModal
          />
        </div>
      </div>
    </div>
  )
}
